"use strict";

function submitNewsletter() {
  collectEmailInput();
  showSuccessMsg();
} // collection email address

function collectEmailInput(event) {
  var emailInput = document.querySelector('input[name="contact[email]"]');

  if (emailInput.value === '') {
    event.preventDefault();
  } else {
    localStorage.setItem('userEmail', emailInput.value);
  }
} // show success message

function showSuccessMsg() {
  var url = window.location.href;
  var ctaContent = document.querySelector('.NewsletterPopup__Content');

  if (url.includes('?customer_posted=true')) {
    hideOverlay();
    var userEmail = localStorage.getItem('userEmail');
    var successMsg = document.querySelector('.Alert--success');
    ctaContent.style.display = 'none';
    successMsg.innerText =
      'Thank you. Your 10% off welcome coupon has been emailed to you at ' +
      userEmail +
      '.';
  }
} // show page overlay behind newsletter modal

function showPageOverlay() {
  var $modal = document.querySelector('[data-section-id=popup]');
  var $overlay = document.querySelector('.PageOverlay');
  var hideModal = $modal ? $modal.getAttribute('aria-hidden') : null;
  addCloseEvents();

  if (hideModal === 'false') {
    $overlay.classList.add('is-visible');
    document.documentElement.classList.add('no-scroll');
  } else {
    $overlay.classList.remove('is-visible');
    document.documentElement.classList.remove('no-scroll');
  }
} // add close events for newsletter modal

function addCloseEvents() {
  var $newsletterForm = document.getElementById('newsletter-popup');
  var $closeModalBtn = document.querySelector('.NewsletterPopup__Close');

  if ($newsletterForm && $closeModalBtn) {
    $closeModalBtn.addEventListener('click', hideOverlay);
    $newsletterForm.addEventListener('submit', submitNewsletter);
  }
} // hide page overlay behind newsletter modal

function hideOverlay() {
  var $overlay = document.querySelector('.PageOverlay');

  if ($overlay.classList.contains('is-visible')) {
    $overlay.classList.remove('is-visible');
    document.documentElement.classList.remove('no-scroll');
  }
}

function showEntryModal() {
  var delay = popupSettings.apparitionDelay * 1000;
  window.setTimeout(showPageOverlay, delay);
} // event listeners

document.addEventListener('DOMContentLoaded', showEntryModal);
document.addEventListener('page:load', showSuccessMsg);
document.addEventListener('page:change', showSuccessMsg);
